import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'oh-search-bar',
  templateUrl: './search-bar.component.html',
  styleUrls: ['./search-bar.component.scss'],
})
export class SearchBarComponent implements OnInit {
  @Input() placeholder: string;
  public value: string;
  constructor() {}

  ngOnInit() {
    this.value = '';
  }

  public setSearchFilter(value){
    this.value = value.toLowerCase().trim();
  }
}
